import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Elements } from '@stripe/react-stripe-js';

import App from './App';
import { stripePromise } from './stripeConfig';
import './styles.css';
import './components/InfoButton.css';
import './components/SelectableChip.css';
import './components/AgentsStep.css';
import './components/SkillsStep.css';
import './components/CodebaseStep.css';
import './components/PricingStep.css';
import './components/InfoModals.css';
import './components/ScanSummary.css';
import './components/ScanLaunchLoading.css';
import './components/FooterBar.css';
import './components/PaidScanPaymentModal.css';

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <Elements stripe={stripePromise}>
        <App />
      </Elements>
    </StrictMode>
  );
}
